/**
 * Fix per il caricamento infinito delle varianti nel tema Panda
 * Questo script risolve il problema dove il loading spinner rimane visibile all'infinito
 */

$(document).ready(function () {

    // Flag per evitare di aggiungere listener multipli
    var listenersAdded = false;

    // Fix per il caricamento infinito delle varianti
    function fixVariantsLoading() {

        // Rimuovi la classe st-input-clicked da tutti i container delle varianti
        $('.product-variants-item .input-container').removeClass('st-input-clicked');

        // Aggiungi i listener solo una volta per evitare memory leak
        if (!listenersAdded && typeof prestashop !== 'undefined') {
            listenersAdded = true;

            // Aggiungi un listener per l'evento updatedProduct di PrestaShop
            prestashop.on('updatedProduct', function (event) {
                // Rimuovi la classe st-input-clicked quando il prodotto è stato aggiornato
                $('.product-variants-item .input-container').removeClass('st-input-clicked');
            });

            // Aggiungi un listener per l'evento updateProduct di PrestaShop
            prestashop.on('updateProduct', function (event) {
                // Rimuovi la classe st-input-clicked quando il prodotto viene aggiornato
                $('.product-variants-item .input-container').removeClass('st-input-clicked');
            });
        }

        // Aggiungi un timeout di sicurezza per rimuovere la classe dopo 5 secondi
        $('body').on('change', '.product-variants [data-product-attribute]', function () {
            var $this = $(this);
            var $container = $this.parent();

            // Aggiungi la classe st-input-clicked
            $('.product-variants-item .input-container').removeClass('st-input-clicked');
            $container.addClass('st-input-clicked');

            // Timeout di sicurezza per rimuovere la classe dopo 5 secondi
            setTimeout(function () {
                $container.removeClass('st-input-clicked');
            }, 5000);
        });

        // Rimuovi la classe anche quando si clicca fuori dalle varianti
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.product-variants').length) {
                $('.product-variants-item .input-container').removeClass('st-input-clicked');
            }
        });

        // Rimuovi la classe anche quando si preme ESC
        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) { // ESC key
                $('.product-variants-item .input-container').removeClass('st-input-clicked');
            }
        });
    }

    // Esegui il fix
    fixVariantsLoading();

    // Esegui il fix anche quando il DOM viene aggiornato (per AJAX)
    $(document).on('DOMNodeInserted', function () {
        if ($('.product-variants').length > 0) {
            fixVariantsLoading();
        }
    });

    // Esegui il fix anche quando la pagina viene caricata completamente
    $(window).on('load', function () {
        fixVariantsLoading();
    });

    // Esegui il fix anche quando si naviga con il browser (back/forward)
    $(window).on('popstate', function () {
        setTimeout(function () {
            fixVariantsLoading();
        }, 100);
    });
});
